export const MODULE_NAME = 'EXPENSES_MODULE';
